import React from "react";

function Welcome() {
  return (
    <h1 style={{ fontSize: 28, fontWeight: "bold", color: "#111", margin: "0 0 4px", fontFamily: "Arial, sans-serif", padding: "0 20px" }}>
      Trainee Portal
    </h1>
  );
}

export default Welcome;
